var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('onboarding',{ref:"onboarding",attrs:{"isSetup":""},on:{"on:completed":_vm.handleSetupCompleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }